import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[650px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20suburban%20home%20exterior%20with%20manicured%20front%20lawn%20beautiful%20landscaping%20soft%20golden%20hour%20sunlight%20filtering%20through%20mature%20trees%20welcoming%20front%20porch%20with%20comfortable%20seating%20elegant%20residential%20architecture%20modern%20traditional%20style%20high%20quality%20real%20estate%20photography&width=1920&height=900&seq=hero-seller-01&orientation=landscape"
          alt="Beautiful suburban home with welcoming front porch and manicured landscaping"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/40 to-foreground-950/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-[800px] mx-auto text-center">
          <p className="text-accent-200 font-body text-sm md:text-base tracking-widest uppercase mb-4 animate-fade-in-up">
            Thinking About Selling?
          </p>

          <h2 className="font-heading text-accent-50 text-2xl md:text-4xl lg:text-5xl leading-tight mb-6 animate-fade-in-up animate-delay-100">
            Let's Make Sure You Get the Right Advice, the Right Strategy and the Best Possible Result.
          </h2>

          <p className="text-background-100/80 font-body text-base md:text-lg leading-relaxed max-w-[650px] mx-auto mb-8 animate-fade-in-up animate-delay-200 [text-shadow:0_1px_4px_rgba(0,0,0,0.45)]">
            Selling a home can feel overwhelming, but it does not have to be. Carol
            Berry provides knowledgeable, personal guidance to help homeowners
            understand their property's value, prepare for the market and move
            forward with confidence.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animate-delay-300">
            <Link
              to="/home-valuation#valuation-form"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-md text-base font-body font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200"
            >
              <i className="ri-home-4-line text-lg" />
              Request Your Free Home Value Consultation
            </Link>
            <Link
              to="/contact#contact-form"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border-2 border-accent-300 text-accent-100 px-8 py-3.5 rounded-md text-base font-body font-semibold whitespace-nowrap hover:bg-accent-300/10 transition-all duration-200"
            >
              <i className="ri-chat-3-line text-lg" />
              Talk to Carol
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-accent-400/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 bg-accent-300 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}